import * as Sentry from '@sentry/react';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://25e740841216842b6abee8610a3ef899@o4511579481702400.ingest.de.sentry.io/4511579708653648',
    release: `wappsto_dashboard@${process.env.REACT_APP_VERSION}`,
  });
}
